import React from "react";
import { useTranslation } from "react-i18next";
import creditCardIcon from "../../../assets/images/payment/card.png";
import "./CardsAmount.scss";

const CardsAmount = ({
  amount,
  setAmount,
  max = 4,
  compact = false,
  locked = false,
  min = 1,
}) => {
  const { t } = useTranslation();

  const handleCardClick = (cardNumber) => {
    if (locked) return;
    if (cardNumber < min) return;
    setAmount(cardNumber);
  };

  return (
    <div
      className={`cards-amount-wrapper${compact ? " cards-amount-wrapper--compact" : ""}${
        locked ? " cards-amount-wrapper--locked" : ""
      }`}
    >
      <label className="splitPayment-card-amount-title">
        {compact ? "כרטיסים לתשלום" : t("paymentagent.setnumcard")}
      </label>
      <div className="credit-cards-icons-container" role="group" aria-label="כרטיסים לתשלום">
        {[...Array(max).keys()].map((i) => {
          const cardNumber = i + 1;
          const isActive = amount >= cardNumber;
          const blocked = locked || cardNumber < min;
          return (
            <button
              type="button"
              key={cardNumber}
              className={`credit-card-icon-wrapper ${isActive ? "active" : ""}${
                blocked ? " is-locked" : ""
              }`}
              onClick={() => handleCardClick(cardNumber)}
              disabled={blocked && cardNumber !== amount}
              aria-pressed={amount === cardNumber}
              aria-label={`${cardNumber} כרטיסים לתשלום`}
            >
              <img
                src={creditCardIcon}
                alt=""
                className="credit-card-icon"
              />
              <span className="credit-card-number">{cardNumber}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CardsAmount;
